
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;
}

  :host figure{
    margin:0;
  }

  :host figure > div{
      display:flex;
      flex-direction:column;
      align-items:center;
      justify-content:center;
    }

  :host figure img{
      max-width:100%;
      height:auto;
    }

  :host figure.full-width,
    :host figure.full-width > div{
      width:100%;
    }

  :host figure.full-width img, :host figure.full-width > div img{
        width:100%;
      }

  :host figure.has-title{
      padding-top:var(--padding-y-sm);
    }
`;